import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScTemplateEmailContent = styled.div`
  width: 100%;
  display: grid;
  justify-items: center;
  gap: 32px;
  text-align: center;

  & > img {
    display: block;
    max-width: 100%;
    border-radius: 12px;
    overflow: clip;
    height: 72px;
    object-fit: cover;
  }

  & > p {
    color: ${({ theme }) => theme.whiteColor};
  }

  & > .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.22px;

    @media (${device.mobile}) {
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.18px;
    }
  }

  & > .description {
    font-size: 14px;
    line-height: 20px;
  }

  & > button {
    width: 232px;

    @media (${device.mobile}) {
      width: 100%;
    }
  }

  & > a {
    width: 232px;

    @media (${device.mobile}) {
      width: 100%;
    }

    & > button {
      width: 100%;
    }
  }
`;
